import React, { useState, useEffect } from "react";
import { setTitle } from "../helpers/MetaTag";
import Select from "../components/form/Select";
import Button from "../components/form/Button";
import toastr from "toastr";

import { postData } from "../services/api";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import OtherPositionPopup from "../components/popup/OtherPositionPopup";
import OtherIndustryPopup from "../components/popup/OtherIndustryPopup";
import OtherStudyPopup from "../components/popup/OtherStudyPopup";
import OtherAreaExpertisePopup from "../components/popup/OtherAreaExpertisePopup";
import SurveyPopup from "../components/popup/SurveyPopup";

const ManageExecutive = () => {
  setTitle("Succession Now | Executive Audit 360");
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const user = useSelector((state) => state.auth?.user);
  const [position, setPosition] = useState([]);
  const [studies, setStudies] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [areaOfExpertise, setAreaOfExpertise] = useState([]);
  const [enabledOtherPositionPopup, setEnabledOtherPositionPopup] =
    useState(false);
  const [enabledOtherStudyPopup, setEnabledOtherStudyPopup] = useState(false);
  const [enabledOtherIndustryPopup, setEnabledOtherIndustryPopup] =
    useState(false);
  const [enabledOtherAreaExpertisePopup, setEnabledOtherAreaExpertisePopup] =
    useState(false);
  const [actionValue, setActionValue] = useState({});
  const [isSave, setIsSave] = useState(false);
  const [yearofexecutive, setYearofExecutive] = useState("");
  const [retirement, setRetirement] = useState("");
  const [areaExpertiseType, setAreaExpertiseType] = useState(0);
  const [executiveDetails, setExecutiveDetails] = useState({});
  const [detailsId, setDetailsId] = useState("");
  const [reatingOptions, setReatingOptions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [enabledSurveyPopup, setEnabledSurveyPopup] = useState(false);
  const [autoSave, setAutoSave] = useState(false);
  const [otherExpertiseType, setOtherExpertiseType] = useState("");

  useEffect(() => {
    const loadExecutiveDetails = async () => {
      try {
        let payload;
        if (role === "customer-executive") {
          payload = {
            id: user?._id,
          };
        } else if (role === "customer-subadmin" || role === "customer-user") {
          payload = {};
        } else {
          payload = {
            _id: id,
          };
        }
        const result = await postData("executive/details", payload);
        if (result.status === 403) {
          return navigate("/executives");
        } else {
          if (result.data) {
            setExecutiveDetails(result.data);
          }
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    if (
      role === "customer-admin" ||
      role === "customer-executive" ||
      role === "customer-subadmin" ||
      role === "customer-user" ||
      id
    ) {
      loadExecutiveDetails();
    }

    async function employeeRatingOptionList() {
      try {
        const result = await postData("employee-rating-option/list", {
          sortQuery: { created_at: 1 },
          status: 1,
          limit: 50,
          type: "executive",
        });
        if (result.data) {
          setReatingOptions(result.data);
        } else {
          console.log("Advance desire message", result.message);
        }
      } catch (error) {
        console.log("Error advance desire catch", error.message);
      }
    }
    employeeRatingOptionList();
  }, [role]);

  useEffect(() => {
    if (Object.keys(executiveDetails).length > 0) {
      setDetailsId(executiveDetails?._id);
      setYearofExecutive(executiveDetails?.board_year);
      setRetirement(executiveDetails?.retirement_window);
      if (
        executiveDetails?.executiveAudits &&
        executiveDetails?.executiveAudits.length > 0
      ) {
        setAnswers(
          reatingOptions.map((value) => {
            let _question = executiveDetails?.executiveAudits.filter(
              (it) => it?.questionId === value?.question?._id
            );
            if (_question.length > 0) {
              return {
                ..._question[0],
                ids: _question[0]?.ids,
                questionInfo: value,
              };
            } else {
              return {
                questionId: value?.question?._id,
                answerId: null,
                answerLabel: null,
                rating: 0,
                comments: null,
                questionInfo: value,
              };
            }
          })
        );
      } else {
        setAnswers(
          reatingOptions.map((value) => {
            return {
              questionId: value?.question?._id,
              answerId: null,
              answerLabel: null,
              rating: 0,
              comments: null,
              questionInfo: value,
            };
          })
        );
      }
    }
  }, [executiveDetails, reatingOptions]);

  useEffect(() => {
    if (actionValue && actionValue.button_type === "study_add") {
      setStudies([...studies, actionValue?.result]);
    } else if (actionValue && actionValue.button_type === "industry_add") {
      setIndustries([...industries, actionValue?.result]);
    } else if (actionValue && actionValue.button_type === "industry_add1") {
      setIndustries([...industries, actionValue?.result]);
    } else if (actionValue && actionValue.button_type === "industry_add2") {
      setIndustries([...industries, actionValue?.result]);
    } else if (actionValue && actionValue.button_type === "area_add") {
      setAreaOfExpertise([...areaOfExpertise, actionValue?.result]);
      if (areaExpertiseType && areaExpertiseType === 1) {
      } else if (areaExpertiseType && areaExpertiseType === 2) {

      }
      setAreaExpertiseType(0);
    } else if (actionValue && actionValue.button_type === "area_add2") {
      setAreaOfExpertise([...areaOfExpertise, actionValue?.result]);
    } else if (actionValue && actionValue.button_type === "area_add3") {
      setAreaOfExpertise([...areaOfExpertise, actionValue?.result]);
    } else if (actionValue && actionValue.button_type === "area_add4") {
      setAreaOfExpertise([...areaOfExpertise, actionValue?.result]);
    } else if (actionValue && actionValue.button_type === "update-survey") {
      setAnswers(actionValue.answers);
      setAutoSave(actionValue.autoSave);
    } else if (actionValue) {
      if(actionValue.button_type !== 'other-position-close'){
        setPosition([...position, actionValue]);
      } 
    }
  }, [actionValue]);

  useEffect(() => {
    if (autoSave) {
      onSubmit();
    }
  }, [autoSave]);

  useEffect(() => {
    async function positionData() {
      try {
        const result = await postData("position/list", {
          sortQuery: { ordering: 1 },
          isBoardMember: 2,
          status: 1,
        });
        if (result.data) {
          setPosition(result.data);
        } else {
          console.log("Position list message", result.message);
        }
      } catch (error) {
        console.log("Error position list catch", error.message);
      }
    }
    positionData();

    async function studyList() {
      try {
        const result = await postData("filter-item/list", {
          sortQuery: { created_at: 1 },
          status: 1,
          type: "study",
        });
        if (result.data) {
          setStudies(result.data);
        } else {
          console.log("Education message", result.message);
        }
      } catch (error) {
        console.log("Error education catch", error.message);
      }
    }
    studyList();

    async function industryList() {
      try {
        const result = await postData("industry/list", {
          sortQuery: { created_at: 1 },
          status: 1,
        });
        if (result.data) {
          setIndustries(result.data);
        } else {
          console.log("Industry message", result.message);
        }
      } catch (error) {
        console.log("Error education catch", error.message);
      }
    }
    industryList();

    async function areaExpertiseList() {
      try {
        const result = await postData("area-of-expertise/list", {
          sortQuery: { created_at: 1 },
          status: 1,
        });
        if (result.data) {
          setAreaOfExpertise(result.data);
        } else {
          console.log("Industry message", result.message);
        }
      } catch (error) {
        console.log("Error education catch", error.message);
      }
    }
    areaExpertiseList();
  }, []);

  // const handelUpdate = async (question_id, answer_id, rating, label, index) => {
  //   setAnswers((answers) =>
  //     answers.map((item, i) => {
  //       if (item?.questionId === question_id) {
  //         if (answer_id === "comments") {
  //           return {
  //             ...item,
  //             comments: rating,
  //           };
  //         } else {
  //           return {
  //             ...item,
  //             answerId: answer_id,
  //             answerLabel: label,
  //             rating: rating,
  //           };
  //         }
  //       } else {
  //         return item;
  //       }
  //     })
  //   );
  // };

  const onSubmit = async (e) => {
    setIsSave(true);
    try {
      let path;
      let payload;
      if (detailsId) {
        path = "executive/update-all";
        payload = {
          id: detailsId,
          executive_year: yearofexecutive,
          retirement_window: retirement,
          ratingOptions: answers
        };
      } else {
        path = "executive/create";
        payload = {
          id: detailsId,
          executive_year: yearofexecutive,
          retirement_window: retirement,
          ratingOptions: answers,
        };
      }
      const result = await postData(path, payload);
      if (result.status && result.status === 200) {
        toastr.success(result.message);
        setIsSave(false);
        setAutoSave(false);
        if (!detailsId) {
          return navigate("/executives");
        }
      } else {
        toastr.error(result.message);
        setIsSave(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsSave(false);
    }
  };

  return (
    <>
      <div className="relative d-flex justify-between items-center mb-4">
        <div className="text-3xl text-slate-800 font-bold">
          {t("executive_audit_360")}
        </div>
      </div>
      <div className="relative grid grid-cols-2 gap-4">
        <div className="col-span-2">
          <div className="relative bg-white rounded shadow divide-y divide-slate-200">
            <div className="py-8 px-6 flex flex-col">
              <div className="space-y-4 mt-4">
                <div className="flex items-start gap-4">
                  <div className="relative w-1/4 max-w-[calc(25%-1rem)]">
                    <Select
                      label={t("years_with_the_company")}
                      labelClasses={"!text-xs !font-semibold"}
                      xPlacement={"left"}
                      selectedValue={yearofexecutive}
                      dropdownClass={"!w-60"}
                      dropdownData={[
                        {
                          _id: " ",
                          label: t("select_years_with_the_company"),
                          value: "",
                        },
                        ...Array(50)
                          .fill()
                          .map((_, index) => ({
                            _id: Number(index + 1),
                            label:
                              Number(index + 1) > 1
                                ? Number(index + 1) + " Years"
                                : Number(index + 1) + " Year",
                            value: Number(index + 1),
                          })),
                      ].filter((itm) => itm)}
                      getSelectedValue={(e) => {
                        setYearofExecutive(e._id);
                      }}
                      requiredDisplay={true}
                    />
                  </div>
                  <div className="relative w-1/4 max-w-[calc(25%-1rem)]">
                    <Select
                      label={t("executive_retirement_window")}
                      labelClasses={"!text-xs !font-semibold"}
                      xPlacement={"left"}
                      selectedValue={retirement}
                      dropdownClass={"!w-60"}
                      dropdownData={[
                        {
                          _id: "",
                          label: t("select_retirement_window"),
                          value: "",
                        },
                        ...Array(50)
                          .fill()
                          .map((_, index) => ({
                            _id: Number(index + 1),
                            label:
                              Number(index + 1) > 1
                                ? Number(index + 1) + " Years"
                                : Number(index + 1) + " Year",
                            value: Number(index + 1),
                          })),
                      ].filter((itm) => itm)}
                      getSelectedValue={(e) => {
                        setRetirement(e._id);
                      }}
                      requiredDisplay={true}
                    />
                  </div>
                </div>                
              </div>
            </div>
            <div className="relative flex justify-between items-center px-5">
              <h5 className="text-black rounded-none w-full font-semibold text-xl px-5 py-3">
                {t("executive_audit_360")}
              </h5>
              <div className="">
                <Button
                  buttonType={"button"}
                  buttonIcon={"fa-light fa-clock"}
                  buttonIconPosition={"left"}
                  buttonLabel={t("start_survey")}
                  buttonHasLink={false}
                  functions={() => {
                    setEnabledSurveyPopup(true);
                  }}
                />
              </div>
            </div>
            <div className="py-3 px-3 border-t border-slate-200">
              <div className="flex items-center justify-end gap-4">
                <Button
                  buttonClasses=""
                  buttonLabelClasses=""
                  buttonType={"button"}
                  buttonIcon={
                    isSave ? "fa-light fa-spinner fa-spin" : "fa-light fa-check"
                  }
                  buttonIconPosition={"left"}
                  buttonLabel={t("submit")}
                  functions={onSubmit}
                  buttonHasLink={false}
                  buttonDisabled={isSave}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {enabledOtherPositionPopup && (
        <OtherPositionPopup
          isOpen={enabledOtherPositionPopup}
          setIsOpen={(val) => setEnabledOtherPositionPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
          data={{ isBoardMember: 2 }}
        ></OtherPositionPopup>
      )}
      {enabledOtherStudyPopup && (
        <OtherStudyPopup
          isOpen={enabledOtherStudyPopup}
          setIsOpen={(val) => setEnabledOtherStudyPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        ></OtherStudyPopup>
      )}
      {enabledOtherIndustryPopup && (
        <OtherIndustryPopup
          isOpen={enabledOtherIndustryPopup}
          setIsOpen={(val) => setEnabledOtherIndustryPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
          otherIndustryType={''}
        ></OtherIndustryPopup>
      )}
      {enabledOtherAreaExpertisePopup && (
        <OtherAreaExpertisePopup
          isOpen={enabledOtherAreaExpertisePopup}
          setIsOpen={(val) => setEnabledOtherAreaExpertisePopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
          otherExpertiseType={otherExpertiseType}
          setOtherExpertiseType={setOtherExpertiseType}
        ></OtherAreaExpertisePopup>
      )}
      {enabledSurveyPopup && (
        <SurveyPopup
          isOpen={enabledSurveyPopup}
          setIsOpen={(val) => setEnabledSurveyPopup(val)}
          data={answers}
          surveyFor={"executive"}
          isConfirmation={detailsId ? true : false}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        ></SurveyPopup>
      )}
    </>
  );
};

export default ManageExecutive;
